import React from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from 'cpool-components/general/Tooltip';
import type { SchemaUserResolver_GetRepresentedUsers } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';
import { LuClock, LuInfo } from 'react-icons/lu';

import { dateFormat } from '~/lib/i18n';

type Props = {
    data: SchemaUserResolver_GetRepresentedUsers[number];
};

export const RepresentationItem: React.FC<Props> = ({ data }) => {
    const { t } = useTranslation();
    const absence = data.absence?.[0];
    const { delegation } = data;

    if (!absence && !delegation) return null;

    return (
        <div className="flex flex-col gap-2 pt-2 pb-4 last:border-b-0 border-b-2 border-stroke border-b-surface-light">
            <p className="text-sm text-midnight">{`${data.firstName} ${data.lastName}`}</p>
            {absence && (
                <div className="flex items-center gap-2">
                    <span className="text-blue-text">
                        <LuClock />
                    </span>
                    <p className="text-sm text-midnight">{dateFormat(absence.absenceFrom)}</p>
                    <p className="text-sm text-midnight mx-2">{t('TOP_HEADER.REPRESENTATION.TO')}</p>
                    <span className="text-blue-text">
                        <LuClock />
                    </span>
                    <p className="text-sm text-midnight">{dateFormat(absence.absenceUntil)}</p>
                </div>
            )}
            {delegation && (
                <div className="flex items-center gap-2">
                    <span className="text-blue-text">
                        <LuClock />
                    </span>
                    <p className="text-sm text-midnight">{dateFormat(delegation.appointedAt)}</p>
                    <p className="text-sm text-midnight mx-2">{t('TOP_HEADER.REPRESENTATION.TO')}</p>
                    <span className="text-blue-text">
                        <LuClock />
                    </span>
                    <p className="text-sm text-midnight">{t('TOP_HEADER.REPRESENTATION.UNLIMITED')}</p>
                    {delegation.appointedByName && (
                        <Tooltip>
                            <TooltipTrigger>
                                <span className="text-blue-text" data-testid="delegation-info-icon">
                                    <LuInfo />
                                </span>
                            </TooltipTrigger>
                            <TooltipContent>
                                {t('TOP_HEADER.REPRESENTATION.SET_BY', { name: delegation.appointedByName })}
                            </TooltipContent>
                        </Tooltip>
                    )}
                </div>
            )}
        </div>
    );
};
